module.exports = __webpack_public_path__ + "static/media/company-header-image.9d59a331.jpg";